import styled from "styled-components"
import { Grid, Button, backdropClasses } from "@mui/material"

export const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  pt: 2,
  px: 4,
  pb: 3,
  borderRadius: "10px",
}
export const ModalInfo = {
  position: "absolute",
  top: "0%",
  right: "0%",
  height: "100%",
  width: "400px",
  backgroundColor: "background.paper",
  borderRadius: "16px 0px 0px 16px",
  overflowY: "scroll",
}

export const ActionModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  backgroundColor: "background.paper",
  padding: "10px",
  borderRadius: "16px",
  width: "393px",
}

export const TagsInput = styled(Grid)`
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  width: 409px;
  padding: 0.5rem;
`
export const CustomButton = styled(Button)`
  width: 140px;
  height: 48px;
  background: #ffd52b;
  border-radius: 6px;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #414141;
`

export const optionBoxStyle = {
  width: "260px",
  marginBottom: "10px",
  position: "relative",
  marginLeft: "0px",
  height: "92px",
  backgroundColor: "#F3F3F3",
  borderRadius: "6px",
  display: "flex",
  paddingTop: "5px",
  paddingLeft: "15px",
}
export const optionSelectStyle = {
  control: base => ({
    ...base,
    height: "30px",
    width: "100%",
    backgroundColor: "#F3F3F3",
    borderRadius: "6px",
    border: "none",
    boxShadow: "none",
    cursor: "pointer",
    fontSize: "13px",
    fontWeight: "400",
    lineHeight: "16px",
  }),
}
export const optionSelectWrapper = {
  width: "260px",
  marginBottom: "10px",
  position: "relative",
  marginLeft: "0px",
  height: "46px",
  backgroundColor: "#F3F3F3",
  display: "block",
  borderRadius: "6px",
  paddingTop: "5px",
  paddingLeft: "4px",
}

export const toggleButtonStyles = {
  "& .MuiToggleButtonGroup-grouped": {
    marginX: "1rem",
    borderRadius: "50px",
    border: "1px solid #FFD52B",
    paddingX: "0rem",
    lineHeight: "15px",
    fontWeight: "300",
    fontSize: "14px",
    fontStyle: "normal",
    fontFamily: "Helvetica",
    textTransform: "none",
    width: "76px",
    color: "#414141",
    opacity: 1,
  },
  "& .MuiToggleButtonGroup-grouped:not(:first-of-type), & .MuiToggleButtonGroup-grouped:not(:last-of-type)":
    {
      borderRadius: "50px",
      border: "1px solid #FFD52B",
    },
  "& .Mui-selected": {
    backgroundColor: "#FFD52B",
    opacity: 1,
  },
}
